import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-contact-dialog',
    templateUrl: './contact-dialog.component.html',
    imports: [TranslateModule, RouterModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ContactDialog {
    private readonly dialogRef = inject<MatDialogRef<ContactDialog>>(MatDialogRef);

    public close(): void {
        this.dialogRef.close();
    }
}
